import React from 'react';
import { Clear as ClearIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { SnackbarKey, useSnackbar } from 'notistack';

const SnackCloseIcon = (key: SnackbarKey) => {
  const { closeSnackbar } = useSnackbar();

  const closeSelectedSnackbar = () => closeSnackbar(key);

  return (
    <IconButton size="small" onClick={closeSelectedSnackbar}>
      <ClearIcon style={{ color: 'white' }} />
    </IconButton>
  );
};

export default SnackCloseIcon;
